// Lift support cart-count bridge.
// Shopify's cart cookie is host-only to liftfoils.com, so support.liftfoils.com
// cannot read it. This writes a minimal domain-shared count cookie for the shared
// header badge. No cart token, products, prices, or customer data are stored.
(function () {
  var COUNT_COOKIE = "lift_cart_count";
  var UPDATED_COOKIE = "lift_cart_updated";
  var MAX_AGE_SECONDS = 60 * 60 * 24 * 31;
  var timer = null;

  function toCount(value) {
    var count = Number(value);
    return Number.isFinite(count) && count > 0 ? Math.floor(count) : 0;
  }

  function writeCookie(name, value) {
    var parts = [
      name + "=" + encodeURIComponent(String(value)),
      "Domain=.liftfoils.com",
      "Path=/",
      "Max-Age=" + MAX_AGE_SECONDS,
      "SameSite=Lax"
    ];
    if (window.location.protocol === "https:") parts.push("Secure");
    document.cookie = parts.join("; ");
  }

  function publishCount(count) {
    count = toCount(count);
    writeCookie(COUNT_COOKIE, count);
    writeCookie(UPDATED_COOKIE, Date.now());
    try {
      window.localStorage.setItem(COUNT_COOKIE, String(count));
    } catch (_) {}
    try {
      window.dispatchEvent(new CustomEvent("lift:cart-count", { detail: { itemCount: count } }));
    } catch (_) {}
  }

  function countFromCartPayload(payload) {
    if (!payload || typeof payload !== "object") return null;
    if (typeof payload.item_count === "number") return payload.item_count;
    if (Array.isArray(payload.items)) {
      return payload.items.reduce(function (sum, item) {
        return sum + toCount(item && item.quantity);
      }, 0);
    }
    return null;
  }

  function refreshCartCount() {
    return fetch("/cart.js", {
      credentials: "same-origin",
      cache: "no-store",
      headers: { Accept: "application/json" }
    })
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .then(function (cart) {
        var count = countFromCartPayload(cart);
        if (count !== null) publishCount(count);
      })
      .catch(function () {});
  }

  function scheduleRefresh(delay) {
    window.clearTimeout(timer);
    timer = window.setTimeout(refreshCartCount, delay == null ? 150 : delay);
  }

  function cartPath(input) {
    try {
      var raw = typeof input === "string" ? input : input && input.url;
      if (!raw) return "";
      return new URL(raw, window.location.origin).pathname;
    } catch (_) {
      return "";
    }
  }

  function isCartMutation(input) {
    return /^\/cart\/(add|change|update|clear)(\.js)?$/.test(cartPath(input));
  }

  function inspectCartResponse(response) {
    try {
      var clone = response.clone();
      var type = clone.headers.get("content-type") || "";
      if (type.indexOf("json") === -1) {
        scheduleRefresh();
        return;
      }
      clone.json()
        .then(function (payload) {
          var count = countFromCartPayload(payload);
          if (count === null) scheduleRefresh();
          else publishCount(count);
        })
        .catch(scheduleRefresh);
    } catch (_) {
      scheduleRefresh();
    }
  }

  if (typeof window.fetch === "function") {
    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      var shouldInspect = isCartMutation(input);
      var promise = originalFetch.apply(this, arguments);
      if (shouldInspect && promise && typeof promise.then === "function") {
        promise.then(inspectCartResponse, scheduleRefresh);
      }
      return promise;
    };
  }

  if (window.XMLHttpRequest && window.XMLHttpRequest.prototype) {
    var originalOpen = window.XMLHttpRequest.prototype.open;
    var originalSend = window.XMLHttpRequest.prototype.send;
    window.XMLHttpRequest.prototype.open = function (method, url) {
      this.__liftCartBridgeUrl = url;
      return originalOpen.apply(this, arguments);
    };
    window.XMLHttpRequest.prototype.send = function () {
      if (isCartMutation(this.__liftCartBridgeUrl)) {
        this.addEventListener("loadend", function () {
          try {
            var payload = JSON.parse(this.responseText || "null");
            var count = countFromCartPayload(payload);
            if (count === null) scheduleRefresh();
            else publishCount(count);
          } catch (_) {
            scheduleRefresh();
          }
        });
      }
      return originalSend.apply(this, arguments);
    };
  }

  function attachPubSub(attempt) {
    if (typeof window.subscribe === "function" && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (event) {
        var payload = event && (event.cartData || event.data || event);
        var count = countFromCartPayload(payload);
        if (count !== null) publishCount(count);
        scheduleRefresh();
      });
      return;
    }
    if (attempt < 20) window.setTimeout(function () { attachPubSub(attempt + 1); }, 250);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      scheduleRefresh(0);
      attachPubSub(0);
    }, { once: true });
  } else {
    scheduleRefresh(0);
    attachPubSub(0);
  }

  window.addEventListener("pageshow", function () { scheduleRefresh(0); });
  document.addEventListener("visibilitychange", function () {
    if (!document.hidden) scheduleRefresh(0);
  });
})();